'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './FormGroup.module.scss';

type GroupProps = BaseComponentProps & {
  children?: ReactNode;
};

function FormGroup({
  style,
  className,
  children,
  testId = 'ui-form-group',
}: GroupProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export { FormGroup };
